module.exports = __webpack_public_path__ + "static/media/logo.19c2e29b.svg";